import React, { useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  BigCheckBoxWrap,
  ButtonM,
  CheckBoxWrap,
  Content,
  Section,
  TextDiv,
} from "../styles/Common";
import { styled } from "styled-components";
import OnlyHeaderLayout from "../components/layout/OnlyHeaderLayout";
import Bird from "../styles/images/point_change_bird.png";
import bgActive from "../styles/images/list_bg_active.png";
import bg from "../styles/images/list_bg.png";
import { ReactComponent as ArrowRight } from "../styles/images/ico_arrow_white.svg";

import SlideModal from "../components/modal/SlideModal";
import OnePageLayout from "../components/layout/OnePageLayout";
import ViewModal from "../components/modal/ViewModal";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../components/hooks/authFunc";
import { mainActions } from "../store/slices/mainSlice";
import { pointActions } from "../store/slices/pointSlice";
import useDidMountEffect from "../components/hooks/useDidMountEffect";
import { Modal } from "../components/modal/Modal";

const PointChangePage = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openFuncModal, setOpenFuncModal] = useState(false);
  const [content, setContent] = useState();
  const navigate = useNavigate();
  const ulRef = useRef();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.point.pointAffiliateList);
  const modalMsg = useSelector((state) => state.point.modalMsg);
  const pointAffiliateLinkSuccess = useSelector(
    (state) => state.point.pointAffiliateLinkSuccess
  );
  const accessToken = getToken();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    const params = {};
    dispatch(pointActions.fetchPointAffiliateList({ params, accessToken }));
  };

  const handlePeerCompany = () => {
    //포인트 연동하기 api
    const params = {
      id: content.serviceId,
    };
    // console.log(params);
    dispatch(pointActions.fetchPointAffiliateLink({ params, accessToken }));
    // if (content) navigate("/point/change/peer", { state: { target: content } });
  };

  const handleRemoveClass = () => {
    const children = ulRef.current.children;
    for (let i = 0; i < children.length; i++) {
      children[i].classList.remove("active");
    }
    setAgreements({
      toPartner: false,
      toCompany: false,
    });
  };

  const handleAddClass = (index) => {
    ulRef.current.children[index].classList.add("active");
  };

  const hasNumber = (arr, targetNumber) => {
    // 배열을 순회하며 숫자가 있는지 확인
    return arr.includes(targetNumber);
  };
  const [viewMode, setViewMode] = useState(false);
  const [target, setTarget] = useState("");
  const [peerTarget, setPeerTarget] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [skipModal, setSkipModal] = useState(false);

  const [allAgreed, setAllAgreed] = useState(false);

  const [agreements, setAgreements] = useState({
    toPartner: false,
    toCompany: false,
  });

  useEffect(() => {
    if (agreements.toPartner && agreements.toCompany) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
    const allChecked = Object.values(agreements).every(
      (value) => value === true
    );
    setAllAgreed(allChecked);
  }, [agreements]);

  const handleAgreementChange = (e) => {
    const { name, checked } = e.target;

    setAgreements((prev) => ({ ...prev, [name]: checked }));
    const allChecked = Object.values({ ...agreements, [name]: checked }).every(
      (value) => value === true
    );
    setAllAgreed(allChecked);
  };

  const handleAllAgreementChange = (e) => {
    const { checked } = e.target;

    setAgreements((prev) =>
      Object.keys(prev).reduce(
        (newAgreedments, agreementKey) => ({
          ...newAgreedments,
          [agreementKey]: checked,
        }),
        {}
      )
    );
    setAllAgreed(checked);
  };
  useEffect(() => {
    if (skipModal && content) {
      navigate("/point/change/peer", { state: { target: content } });
      // handlePeerCompany();
    } else {
      return;
    }
  }, [skipModal]);

  useDidMountEffect(() => {
    if (pointAffiliateLinkSuccess)
      navigate("/point/change/peer", { state: { target: content } });
  }, [pointAffiliateLinkSuccess]);

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);
  return (
    <>
      {viewMode && (
        <ViewModal
          title="이용약관"
          setAgreements={setAgreements}
          setViewMode={setViewMode}
          target={target}
          content={content}
        />
      )}
      <OnlyHeaderLayout title="포인트 교환">
        {openModal && (
          <Modal setOpenModal={setOpenModal}>
            <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
          </Modal>
        )}
        {openFuncModal && (
          <SlideModal
            btnText={"연동하기"}
            setOpenModal={setOpenFuncModal}
            closeModalFunc={handleRemoveClass}
            callbackFunc={handlePeerCompany}
            btnDisabled={btnDisabled}
            autoClose={true}
          >
            <h3>{peerTarget}와 연동을 원하세요?</h3>
            <p className="smallP">
              {peerTarget} 회원이신 경우,
              <br />
              아래 개인정보 제공에 동의 해주시면 <br /> 적립한 포인트를 연동할
              수 있습니다.
            </p>
            <Detail>
              <AgreeWrap>
                <LabelWarp>
                  <BigCheckBoxWrap>
                    <input
                      type="checkbox"
                      name="allAgree"
                      id="allAgree"
                      checked={allAgreed}
                      onChange={handleAllAgreementChange}
                    />
                    <label htmlFor="allAgree">모두 동의합니다.</label>
                  </BigCheckBoxWrap>
                </LabelWarp>
              </AgreeWrap>
              <AgreeWrap>
                <LabelWarp>
                  <BigCheckBoxWrap>
                    <input
                      type="checkbox"
                      name="toPartner"
                      id="toPartner"
                      checked={agreements.toPartner}
                      onChange={handleAgreementChange}
                    />
                    <label htmlFor="toPartner">
                      운영사가 제휴사에게 제공{" "}
                      <span className="col"> [필수]</span>
                    </label>
                  </BigCheckBoxWrap>
                  <ArrowRight
                    onClick={() => {
                      setTarget("toPartner");
                      setViewMode(true);
                    }}
                  />
                </LabelWarp>
              </AgreeWrap>
              <LabelWarp>
                <BigCheckBoxWrap>
                  <input
                    type="checkbox"
                    name="toCompany"
                    id="toCompany"
                    checked={agreements.toCompany}
                    onChange={handleAgreementChange}
                  />
                  <label htmlFor="toCompany">
                    제휴사가 운영사에게 제공{" "}
                    <span className="col"> [필수]</span>
                  </label>
                </BigCheckBoxWrap>
                <ArrowRight
                  onClick={() => {
                    setTarget("toCompany");

                    setViewMode(true);
                  }}
                />
              </LabelWarp>
            </Detail>
          </SlideModal>
        )}
        <PointChangeSection>
          <PointChangeContent>
            <IntroduceTextDiv>
              <div>
                <h3>
                  보유하고 있는 제휴사 포인트를
                  <br />
                  뮤포인트로 교환하고 싶으신가요?
                </h3>
                <p>
                  아래 서비스 연동하기 버튼을 클릭해 가입되어 있는 <br />
                  서비스의 포인트를 뮤포인트에 연동 하실 수 있습니다.
                </p>
              </div>
              {data.count > 0 ? (
                <ListWarp ref={ulRef}>
                  {data.count > 0 &&
                    data.list.map((li, index) => (
                      <li key={index}>
                        <Company className="company">
                          <Title className="title">{li.service}</Title>
                          <Info className="info">
                            {/* 연동하면
                            <br />
                            <span>500포인트</span> 적립 */}
                            {li.title}
                          </Info>
                        </Company>

                        {hasNumber(data.data, li.serviceId) ? (
                          <button
                            onClick={() => {
                              setPeerTarget(li.service);
                              handleAddClass(index);
                              setContent(li);
                              setSkipModal(true);
                            }}
                          >
                            교환하기
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              setPeerTarget(li.service);
                              handleAddClass(index);
                              setOpenFuncModal(true);
                              setContent(li);
                            }}
                          >
                            연동하기
                          </button>
                        )}
                      </li>
                    ))}
                </ListWarp>
              ) : (
                <h5>포인트 교환을 할 수 있는 제휴사가 없습니다.</h5>
              )}
            </IntroduceTextDiv>
          </PointChangeContent>
        </PointChangeSection>
      </OnlyHeaderLayout>
    </>
  );
};

export default PointChangePage;

const PointChangeSection = styled(Section)`
  padding-top: 0;
  background-color: ${({ theme }) => theme.color.purple_bg};
`;

const PointChangeContent = styled(Content)`
  padding: 0 1.6rem;
`;

const IntroduceTextDiv = styled(TextDiv)`
  h3 {
    letter-spacing: -0.48px;
    text-align: left;
    display: flex;
    justify-content: center;
    align-items: end;
    &::before {
      display: block;
      content: "";
      width: 4.1rem;
      height: 6.8rem;
      background: url(${Bird}) center center/cover no-repeat;
      margin-right: 1rem;
      margin-top: 0.4rem;
    }
  }
  p {
    letter-spacing: -0.42px;
    margin-top: 1.5rem;
  }
  h5 {
    margin-top: 4rem;
  }
`;

const ListWarp = styled.ul`
  margin-top: 4rem;
  li {
    &:nth-of-type(1) {
      margin: 0 auto;
    }
    width: 100%;
    max-width: 34.3rem;
    max-width: 45rem;
    margin: 1.5rem auto 0 auto;
    height: auto;
    min-height: 9rem;
    background: url(${bg}) center center/cover no-repeat;
    fill: #fff;
    filter: drop-shadow(0px 3px 10px rgba(33, 23, 95, 0.15));
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2rem;
    @media screen and (max-width: 280px) {
      padding: 0 0.5rem;
    }
    button {
      /* width: 30%; */
      height: 9rem;
      color: ${({ theme }) => theme.color.purple_primary};
      font-family: NanumSquareB;
      font-size: 1.8rem;
      line-height: 1.8rem; /* 100% */
      background-color: transparent;
      border: 0;
      @media screen and (max-width: 280px) {
        font-size: 1.2rem;
      }
    }
    .company {
      width: 70%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: start;
      color: ${({ theme }) => theme.color.black};
    }
    .title {
      /* width: 10.3rem; */
      width: 50%;
      font-size: 1.8rem;
      font-weight: 700;
      line-height: 2.2rem; /* 100% */
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .info {
      /* width: 10rem; */
      width: 45%;
      font-size: 1.2rem;
      font-weight: 400;
      line-height: 1.6rem; /* 133.333% */
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${({ theme }) => theme.color.input_text_gray_dark};
      span {
        color: ${({ theme }) => theme.color.black};
        font-weight: 800;
      }
    }
  }
  li.active {
    background: url(${bgActive}) center center/cover no-repeat;

    button {
      color: ${({ theme }) => theme.color.yellow};
    }
    .company {
      color: ${({ theme }) => theme.color.black};
    }
    .title {
      color: ${({ theme }) => theme.color.white};
    }
    .info {
      color: ${({ theme }) => theme.color.white};
      span {
        color: ${({ theme }) => theme.color.white};
      }
    }
  }
`;

const Company = styled.div``;
const Title = styled.div``;
const Info = styled.div`
  margin-left: 1rem;
`;

const AllAgreeWrap = styled.div`
  padding: 1rem 0 2rem 0;
  border-bottom: 1px solid #000;
`;

const AgreeWrap = styled.ul`
  /* margin-top: 1rem; */
`;

const LabelWarp = styled.li`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  label {
    font-size: 1.4rem;
    line-height: 1.4rem;
    span {
      margin-left: 0.5rem;
    }
  }
  .col {
    color: ${({ theme }) => theme.color.yellow};
  }
`;

const Detail = styled.div`
  padding: 3rem 0;
`;
